var map = {
	"./lesson_1_1.pdf": 852,
	"./lesson_1_2.pdf": 853,
	"./lesson_1_3.pdf": 854,
	"./lesson_1_4.pdf": 855,
	"./lesson_1_5.pdf": 856
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 851;